import { ReactNode } from 'react';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';

type AppLayoutProps = {
  title?: string;
  toolbar?: ReactNode;
  children: ReactNode;
};

export const AppLayout: React.FC<AppLayoutProps> = ({ title, toolbar, children }) => {
  return (
    <div className="layout-dashboard">
      <Topbar />
      <Sidebar />
      <section className="content">
        {title && (
          <header className="content-header">
            <div>
              <h2>{title}</h2>
              <p className="subtle-text">Overview of monthly performance and pending actions.</p>
            </div>
            {toolbar && <div className="content-toolbar">{toolbar}</div>}
          </header>
        )}
        {children}
      </section>
    </div>
  );
};

